<script lang="ts">
  import SplitLines from '$components/split-lines.svelte';
  import Button from '$components/ui/button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { aboveLg } from '$lib/stores/breakpoints';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { TextStoryblok } from '$types/bloks';

  export let block: TextStoryblok;

  let className: string | undefined = undefined;
  export { className as class };
</script>

<div use:storyblokEditable={block} class={cn(className)}>
  <h2 class="text-3xl font-semibold">{block.title}</h2>
  <SplitLines text={block.description} class="text-xl text-primary/80 mt-2 flex flex-col gap-2" />

  {#if block.cta?.[0]}
    {@const { href, rel, target } = $getAnchorFromCmsLink(block.cta?.[0].link)}
    {@const variant = block.cta_color}
    <Button
      as="a"
      size={$aboveLg ? 'md' : 'sm'}
      {variant}
      {href}
      {rel}
      {target}
      class="mt-5 lg:mt-6"
    >
      {block.cta[0].label}
    </Button>
  {/if}
</div>
